<template>
    <div class="vue-locations-alphabetically">
        <div class="alphabet-wrapper row">
            <h2 class="virtual-h3">{{ translations.allLocationsInOneRow }}</h2>

            <div class="alphabet col-lg-8">
                <template v-for="char in availableAlphabet">
                    <a :href="`#${char}-location-set`"><span>{{ char }}</span></a>
                </template>
            </div>
        </div>

        <div class="locations-alphabetic-wrapper">
            <aut-location-set
                v-for="(location, index) in locationsSet"
                :key="index"
                :character="index"
                :location-set="location"
            ></aut-location-set>
        </div>
    </div>
</template>

<script>
import LocationSet from "./LocationSet";
import translations from "../../mixins/translations";

export default {
    name: "LocationsByPlace",

    mixins: [translations],

    components: {
        'aut-location-set': LocationSet
    },

    data() {
        return {
            locationsSet: [],
        }
    },

    computed: {
        availableAlphabet() {
            return lodash.keys(this.locationsSet);
        },
    },

    created() {
        this.fetchData();
    },

    methods: {
        fetchData() {
            axios.get('/api/locations/all')
                .then(response => {
                    this.locationsSet = response.data;
                });
        }
    }
}
</script>
